import { GridButtons } from "@/controls/buttons/GridButtons";
import { Carrier } from "@/pages/catalogs/models/Carrier";
import {
	assemblyStatusCodes,
	CarrierAssemblyStatusTag,
} from "@/pages/mill/carriers/components/CarrierAssemblyStatusTag";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";

type Props = {
	setSelectedRowData: (carrier: Carrier) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "SectionName",
			headerName: "Section",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "StandName",
			headerName: "Stand",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "LocationName",
			headerName: "Location",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "CarrierStatusCode",
			headerName: "Status",
			minWidth: 20,
			maxWidth: 70,
			flex: 1,
			valueGetter: (params) =>
				assemblyStatusCodes.find(
					(code) => code.Code === (params.data as Carrier).CarrierStatusCode,
				)?.Name,
			cellRenderer: CarrierAssemblyStatusTag,
			cellRendererParams: (params: ICellRendererParams) => ({
				status: assemblyStatusCodes.find(
					(code) => code.Code === (params.data as Carrier).CarrierStatusCode,
				),
			}),
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as Carrier,
				setShowModal: setShowModal,
				edit: false,
				showContextMenu: () =>
					showContextMenu(event, params.data, "carrierContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			flex: 1,
			maxWidth: 180,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
